module.exports = {
    environment: process.env.ELEVENTY_ENV,
    name: "IM Properties - Thrapston Business Park",
    url: process.env.ELEVENTY_ENV === 'dev' ? 'https://thrapston-consultation-test.netlify.app' : 'https://www.impthrapston.co.uk',

    base: {
        "contact_address": "IM Properties, c/o Camargue, 11 Waterloo Street, Birmingham B2 5TB",
        "contact_number": "03308 384 199",
        "contact_email": "info@impthrapston.co.uk"
    },

    meta: {
        "defaultSocialImage": "/assets/images/social.jpg",
        "author": "",
        "description": "",
        "gtag": "G-LXRPF8DCET",
        "gtm": "GTM-5DJHR36"
    },

    form: {
        "contact": {
            "catcher_id": "",
            "recaptcha": "",
            "honeypot": ""
        },
        "feedback": {
            "catcher_id": "",
            "recaptcha": "6LcGdoccAAAAAHr5_yxxsFdRGpZQH5X_aQNFLySL",
            "honeypot": ""
        }
    },

    consultation: {   
        "feedback_active": false, 
        "start_datetime": "",
        "end_datetime": "",

        "themes": [
            {
                "name": "Layout and design",
                "feedback_url": '',
                "icon": "layout-design",
                "question": "Do you have any comments on the proposed layout and design of buildings?",
                "key": "01-section"
            },
            {
                "name": "Landscaping",
                "feedback_url": 'page-2/',
                "icon": "landscaping",
                "question": "Do you have any comments on our landscape-led approach?",
                "key": "02-section"
            },
            {
                "name": "Biodiversity",
                "feedback_url": 'page-3/',
                "icon": "environment",
                "question": "Do you have any comments on our plans to deliver biodiversity net gain?",
                "key": "03-section"
            },
            {
                "name": "Public access",
                "feedback_url": 'page-4/',
                "icon": "public-access",
                "question": "Do you have any comments on the opportunities to enhance public access?",
                "key": "04-section"
            },
            {
                "name": "Social value and community",
                "feedback_url": 'page-5/',
                "icon": "social-value",
                "question": "Do you have any comments on options for the off-site land or other potential community benefits?",
                "key": "05-section"
            },
            {
                "name": "Environment",
                "feedback_url": 'page-6/',
                "icon": "drainage",
                "question": "Do you have any comments on environmental considerations, including drainage, lighting or noise?",
                "key": "06-section"
            },
            {
                "name": "Transport",
                "feedback_url": 'page-7/',
                "icon": "highways-transport",
                "question": "Do you have any comments on our approach to transport?",
                "key": "07-section"
            }
        ]
    },

    hasMap: true,

    // Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
    mapUrl: process.env.ELEVENTY_ENV === 'dev' ? 'https://thrapston-map.test' : 'https://feedback.impthrapston.co.uk',

    // Bugsnag API Key
    bugsnagApiKey: '0450df5d2a4beabd54996611c558a38b',

    // Marker IO
    marker_io: "6602cf8456bc21103f2f0397",

};
